<template>
  <div>
    <div class="main">
      <div class="main__graphic">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          viewBox="-3 -3 27 27"
          style="enable-background: new 0 0 50 50; padding-left: 450px"
          xml:space="preserve"
          class="brain-svg"
        >
          <g id="brain">
            <animateTransform
              attributeName="transform"
              type="scale"
              values=".13; .132; .13; .132; .13"
              dur="7s"
              repeatCount="indefinite"
              additive="sum"
            ></animateTransform>

            <g id="brain-base">
              <path
                class="cls-1"
                d="M105.57,148.43c-3.28-.31-6.56-5.1-9.69-14.15L91,125.15a3.31,3.31,0,0,1-2.58-.11c-2.5-1.09-4.57-4.8-6.17-11-3-.16-25.91-1.65-28.1-9.16a7.84,7.84,0,0,1,1.36-4.75c.93-1.44,2.59-1.53,4.2-1.61a13.74,13.74,0,0,0,1.5-.13c2.74-.43,5.43-1.49,12.53-6.13.46-.31,10.59-7,17.41-4.85a7.47,7.47,0,0,1,4.66,4.27c1.68,3.67,3.64,8.1,5.44,13.16A8.37,8.37,0,0,0,102.6,107c1.07,1.39,2.29,3,1.59,4.88a7.22,7.22,0,0,0,.1,5.74,24.33,24.33,0,0,1,.71,2.48,9.42,9.42,0,0,0,.67,2.19c.42,1,1.06,2.43,3.34,12.77a49.92,49.92,0,0,1,.83,7.64c0,.9.1,1.82.17,2.75v.14l-.06.12c-.07.11-1.54,2.78-4,2.78Zm3.47-5.72a50.09,50.09,0,0,0-.81-7.49c-2.26-10.26-2.88-11.67-3.29-12.6a10.49,10.49,0,0,1-.72-2.36,21.92,21.92,0,0,0-.69-2.39,8.12,8.12,0,0,1-.09-6.37c.53-1.43-.43-2.67-1.45-4a9.16,9.16,0,0,1-1.5-2.37c-1.79-5-3.74-9.44-5.41-13.09a6.72,6.72,0,0,0-4.16-3.82c-6.49-2-16.68,4.69-16.78,4.76h0c-7.22,4.72-10,5.81-12.83,6.25-.5.08-1.05.11-1.57.14-1.48.08-2.88.15-3.59,1.24a7.33,7.33,0,0,0-1.23,4.06h0c2.11,7.2,27.39,8.47,27.64,8.48h.29l.08.31c1.91,7.59,4.19,10,5.76,10.73a2.48,2.48,0,0,0,2.26,0l.35-.23,5.3,9.91c3.79,10.93,7,13.45,9,13.65s3.27-1.74,3.57-2.23C109.14,144.43,109.09,143.56,109,142.71Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-2"
                d="M74.38,89.05s17.05-11.87,21.87-.88c1.75,4,3.69,8.63,5.47,13.83.77,2.28,4,4.28,3,7-1.42,4,0,5.35.78,8.95.91,4.36.58-.68,4,15.78a85.43,85.43,0,0,1,1,10.88s-5.88,11.24-13.57-12l-5.12-10s-5.11,3.49-8.72-11.56c0,0-26.2-1.19-28.44-9.18A8.12,8.12,0,0,1,56,97.29c1.13-1.81,3.59-1.35,5.52-1.67C64.46,95.13,67.29,93.87,74.38,89.05Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-2"
                d="M102.62,93.44c4.14-2.83,10.38-3.74,15.25-4.4.54-.6,1.11-1.21,1.73-1.82,5.71-5.58,10.85-10.81,19-12.35,1.75-.32,3.76,2.78,4.51,5,3.47,1.54,17.91,21.23,17.87,21.44-.74,3.88-2.44,5-6.42,4.9-1.11-.3-7.12,10.68-8.2,10.56-2.16-.24-2.35-1.43-4.25-2.4,2,5.57-2.74,7.4-5.46,9.43-3.18,2.39-33.22-10.1-33.95-14.64,0,0-.35.18-2.29-5.16C99.15,100.41,99.11,95.84,102.62,93.44Z"
                transform="translate(-0.63 0.13)"
              />

              <path
                class="cls-2"
                d="M21.78,60.35a24.51,24.51,0,0,1,.36-3.28c2.62-8.39,6.65-19.21,16.63-22.52,2.33-.78,4.77-1.25,7.11-2,2.72-.9,5.08-2.45,7.78-3.37a21.59,21.59,0,0,1,7-1.06,2.44,2.44,0,0,1,.07-.39c.72-2.25,6.18-1.11,8.12-1.06,2.87.07,6.35.65,9-.59-.1-.72-.06-1.24.23-1.26a7.53,7.53,0,0,1,2.36.3c0-.45,0-.73,0-.73.57,0,1.1.54,1.57,1.35a23.45,23.45,0,0,1,2.87,1.78.22.22,0,0,1,.25,0,22.17,22.17,0,0,0,5.21,1.74L103.11,31a22.11,22.11,0,0,1,6.54-.17c9.1,1.48,16.18,8.14,22.21,13.92A8.23,8.23,0,0,1,133.42,47c1.55,1.5,2.24,4.3,2.79,6.14,0,.17.18.79.29,1.51.21.4.41.81.6,1.21a15.37,15.37,0,0,1,3.17,3.57A24.86,24.86,0,0,1,143.59,64a24.47,24.47,0,0,1,2,4c.17.48,1,2.25-.3,2l-.5.57c.39,1.06.52,1.92.22,2.28a32.91,32.91,0,0,1-11.74,8.9c-2.49,2.4-4.9,4.9-7.55,7.25-3.1,2.76-6.14,3.85-10.37,4.79-2.91.65-6.47.69-9.33,1.74-.38.71-7.32,2.78-7.71,3.92,0,.12-5.5-12-5.84-12.86s-2.47,4.08-5.68,2c0,.68-14.34-1.08-19.21-.93a1,1,0,0,1-.24,0l-.69.38-.35.19s0,.08,0,.08h-.07l-.53.56c-.07.07-.18,0-.31-.18l-.08,0s0,0,0,0h-.06c-1.73.81-4.36,2-4.38,1.56-.1-1.58.56-3,.82-4.53a11,11,0,0,0-.46-5.06h0c-1-1.52-2-3-2.79-4.61L58.25,76l-.28-.3c-1.1-.82-3,.61-4.15.12-3.18,0-5.5-2.06-8.67-1.86a1,1,0,0,1-.77-.38,26,26,0,0,1-4.61.81c0,.18-.11.3-.23.3a20,20,0,0,1-7.2-1c-2.18-.84-3.08-2.44-4.73-3.81-.59-.49-3.38-3-3.56-3.13-.43-.27-1.1-.57-1.67-.93C21.74,66.06,21.6,61.68,21.78,60.35Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-1"
                d="M32.67,69.33a6.17,6.17,0,0,1,5.91,1.89c1.18,1.38,1.84,3,3.29,4.21l.34.23a16.23,16.23,0,0,0,1.36,1.15,7,7,0,0,0,6,1.09,16.65,16.65,0,0,1,3.83-.57c1.25,0,2.47.36,3.73.39,2.54,0,5.11-.46,7.54.43l.06,0a6.59,6.59,0,0,1,1.61,2.89c1,3.78-2.33,7.84-5.11,10.19-.25.21,4.45,2.94,4.59,2.81,2.92-2.54,5.88-5,9.68-6.07,2-.58,4.14-1,6.21-1.38,1.86-.38,9.32-.56,10.74,0s9.66,23.14,10.4,24.87c-.41-2.19.26-13.26,1.42-15,3.11-4.72,13.18-3,13.55-3.17a51.89,51.89,0,0,0,7.69-5.57A17.44,17.44,0,0,1,128.81,85a64,64,0,0,0,5.79-4.38c2.24-1.88,4.39-3.94,4.94-5.28a6.84,6.84,0,0,0,1.09-3.59,1.26,1.26,0,0,0-.16-.46l-.09-.16a3.38,3.38,0,0,0-.62-1.5c-.92-1.54-1.89-3.06-2.9-4.54a31.86,31.86,0,0,0-6.11-6.89l-.67-.84a.19.19,0,0,1,0-.08c-.07-4.61-3.81-9-6.75-12.15a46,46,0,0,0-11.12-8.79l.37,0c-.13,0-.48-1.75-1-1.8-8.71-.75-20.38,2.05-27.42-4.5a.09.09,0,0,1,0,0c-.19-.54-.85-1.6-1-1.5l-.26.14-.08-.09c-.3-.38-.24-.14-.22.12a.45.45,0,0,1,0,.11,17.47,17.47,0,0,1-7.42,2,20.56,20.56,0,0,1-4.29-.37,4.88,4.88,0,0,0-3.33.26c-1.07.62-22.72,4.9-27.81,10.25-1.54,1.61-.51,4.64-1.66,6.54A26.15,26.15,0,0,0,35,54c-.68,2.47-4.2,1.59-4.47,4.12-.23,2.05,3.05,8.15,1.14,9.41C31.41,67.67,32.36,69.39,32.67,69.33Zm1.5-2c.53-1.36,1.54-3.24.75-4.33-6.3-8.76.8-7.84.92-7.74,2.28,2,6.34.89,7.72-.73.08-.09,3.66,2.37,4.12.94a31.39,31.39,0,0,1-3.11-2.16c2-3.14,4.41-7.4,7.54-2.34.1.15-1.11-3.27-1.06-3.11-4.66-2.3-6.42,5.46-10.46,6.5A1.63,1.63,0,0,1,38.79,52a12.72,12.72,0,0,0,.62-1.57s-1.43-4.95-.8-5.59c0,0,1.32-3.85,3.55-4.49,2.46-.7,13.35-2.41,15.66-3.51a25.08,25.08,0,0,1,6.34-2.14,6.77,6.77,0,0,0,3.22-1.27,4.16,4.16,0,0,1,2.9-1.38c1.22,0,2.43.37,3.65.48a16.44,16.44,0,0,0,3.29,0c2.25-.23,25.36,2.79,25.37,2.8,1,.47,1.57,1.76,2.66,1.9.54.07-2,6-4.11,4.88-2.27-1.28-3.64-.85.26,1.54,3,1.86,5.64-4.81,5.78-5.19.3-.85.63-1.5,1.46-1.12.62.28,5.08,5.5,4.12,7.52a3,3,0,0,0,1.56-2.36,8.78,8.78,0,0,0-1.27-3.86c-.17-.28-.37-.56-.57-.83A44.92,44.92,0,0,1,122,44.73a41.8,41.8,0,0,1,4.66,5.21c1.54,2.07,4.73,10,5.07,10.29a42.25,42.25,0,0,1,3.54,5.49c1,2.29.85,1.53.58,4,0,0,1.28,2.6,1.28,2.61-.13.35-3,5.21-5.15,6.66a37.29,37.29,0,0,0-7.24,6.26c-2.29,2.73-5.33,5.57-9,6.64-1.68.5-7.36-1.39-7.32-1.29-.53.05-5.72,2.73-5.87,2.81-.34-.73-1.48-2.81-4.32-8.4a11.64,11.64,0,0,0,3.54-2c2.88-2.79,1.23-6.11-3.54-9.85,0,0,6.6,7.3-.76,10-.47.17-1.63-2.46-1.94-3,0,0-1.24.18-1.28.39-.45,2.06,6.56,13.85,6.82,14.16-.25-.15-6.9-9.23-7.55-10s-10.26-.66-11.67-.51a28.17,28.17,0,0,0-8.65,2c-1.26.55-14.44,7.41-15.62,8.11-.6.35-12.84-18.5-13.76-18.79a8.23,8.23,0,0,1-2.63-2.05c-1.42-1.48-3.9-4.6-4.71-5.13S34.14,67.43,34.17,67.35Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-2"
                d="M101.8,98c.14-.21,1.94-8.79,13.79-4.89.6-1,2.82-2.24,3.31-1.76A26.17,26.17,0,0,1,125.61,93c.25.16.88.95.81,1.33.36,0,3.51-.91,3.43-.23.11,0,4.54,5.07,4.43,5.32,0,0,9.23-3.6,6.94,3-.8,2.3,1.35,5.12,1.5,8.84.42,9.92-2.54,10.64-3.38,11.28-.12.1-11.91,8.06-13,8.36-.82.22-.9-.62-4-.51-2.85.1-4.4,2.09-6.41,2.1-3.35,0-6.46-2.41-8-5.95C105.12,120,99.16,99.79,101.8,98Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-1"
                d="M114.32,92.2c.52,0,.87.6,1.27.94.18-.57,2.79-1.75,3.31-1.76,1.55,0,6.69,1.09,7.18,2.09a4.48,4.48,0,0,1,.34.9l2.09-.18c.84-.07,1.62-.26,2.23.45s3.65,5,3.9,5.32c1.59-.24,6.93,3.08,7.14,3.34,4.29,5.27,1,9.88,1,10.9,2.77,5.32-16.32,17.18-16.32,17.18-1.16.05-1.76-.9-2.92-.85a6.71,6.71,0,0,0-3,.53c-1.71.76-3.45,1.73-5.39,1.42s-3-.26-4.43-1.65c-3.26-3.16-5.88-19.85-5.69-21.72.11-1.1,1.92-5.4,3-5.49.12,0-2.11,4.43-2.07,5.19a7.78,7.78,0,0,0,1.06,3.46c.38-.82,2.78-1.26,2.81-1.22.16.25.58.8.51,1.13-.39,2-2.15,3.72-1.75,5.93.17.93,7.37,1,7.25,1a6.52,6.52,0,0,0-4.27,2.33c-1.1,1.36-1.53,5-.27,6.23,4.51,4.35,9.55,1.58,11.76,1.25.86-.13-.74-8.79-1-9.78-2.54-8.15-3.83-8.29-3.92-8.5s.4-3.14-1.5-3.17a19,19,0,0,0-4.88,1.18c-.3.19,1.68-4.59,2.29-5.57,1.21-2.51,4.12.43,4.13.38.54-2.66,1.8-4.39,2-4a12.94,12.94,0,0,0,2.27,3c1.06,1,5.33-.07,5.33-.06a31.42,31.42,0,0,0-1.49,3.39c-.26,1.36-1.52,5.93-1.51,5.79.06-.74-3-4.79-3.39-4.79s-1.1,2.24-1.6,3c2.8,2.78,7.65,18.9,7.8,19.11,3.25-.22,5.62-2.26,7.52-4.85a4.75,4.75,0,0,0,.21-5.28c-.55-.89-7.86-9.24-8-9.55,0-.08,3.49,3.27,5.3,5.33s6.78,5.6,8.61,2.85c.16-.24-1-4.54-.79-5.15a17.1,17.1,0,0,0,1.36-4.13,6.84,6.84,0,0,0-1.89-4.41s-5.76-3.61-5.73-3.62-3-4.25-3.54-4.26-3.1.27-4,.35a13.28,13.28,0,0,1-.26,3.4,2.8,2.8,0,0,1-1.32,1c-.31.17-2.7-.53-2-1.11s1.83-.8,2.27-1.61c.26-.49-.33-2.6-.32-3.14s-5.73-2.61-7.84-1c-.12.08,0,5.75,0,5.76.07-.22-1.79-5-2.43-5.18-11.66-2.36-12.46,14.23-12.33,12.37C102.58,105.08,100.52,91,114.32,92.2Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-2"
                d="M7.52,65.87c-.2-1,.45-7.72.9-8.31-.62-2.18-.47-4.24,1.2-4.24a3.1,3.1,0,0,1,2.67,1.94c-.56-1.83-3.47-17.39.3-19.94.76-.52,5.26-3.25,6.76-3.4C21.1,29.08,24,27,27.13,25.41a1.7,1.7,0,0,1,1.79.28,28.21,28.21,0,0,1-.18-3.44c0-.6,7-3.14,7.28-3.24a21.63,21.63,0,0,0,4.26-1.66c.2-.51,2.26-7.47,12.14-6.11a9.9,9.9,0,0,1,3,.89C57,8.18,63.6,8.54,68,9.05A19.71,19.71,0,0,1,76.8,5.42c3.92-.42,6.13,2.5,7.92,4.84,2.71.44.88-4.11,7.19-3.19a31,31,0,0,1,4.23.69s5.86,1.16,6,1.23c2.21,1.1,13,3.22,13.3,3.22,2.15,0,1.74,6.83,1.68,9.56.06-.08,1,1.6,2,1.33,1.19-.35.24-3.09,4.78-1.75,1.74.51,2.21,3.67,3.86,4.92,2.06,1.58,5.15,1.26,5.29,1.48.63.22,9.19,5.41,9.41,5.51a15,15,0,0,1,3.45,3.46,18.12,18.12,0,0,1,3.59,8.82c.49-.7-.18-.8.69-1.14,5.39-2.09,5.2,13,5.32,14.74.43,0,5.56,3.85,4.48,8.85-.33,1.51,9.6,21.93,6.79,31.73-.28,1-1.2.64-4.63,1.13-1.93.28-14.65-12.3-18.61-19.88-1.12-2.14-2.62-3.78-3.73-6.31h0c-5.13-1.48-6.48-6.83-7.06-7.44-.3,0-4.69-2.71-5.41-5.12a8,8,0,0,1-.55-.8,7.64,7.64,0,0,1-2.24-3.09c-.73-1.11-10.24-14.79-10.51-16.08-.47-1.16-3.74-4.06-4.65-5.5-1,1.86-5.24,1.51-6.88.82-.06,0-8.81-3-12.58-3.34-8.45-.84-14-1.35-14-1.35S44.67,41.39,43.34,41A9.25,9.25,0,0,1,42,44.49a2.59,2.59,0,0,1-2.49.35c-.25-.16-.49-.34-.73-.51.06,2.31.32,5.21-.74,7.09-.44.8-1.23,1.25-1.75,2a8.87,8.87,0,0,0-1.14,3.64c-.2,1.12,12.3,18.29,14.53,19C50.1,76.15,62.34,75,62.35,75c8.45,4,1.78,11.65,1.49,12.12-3.89,6.33-10.6,9.08-17.67,10.3-1.21.2-5.27,2.88-5.27,2.9-1.6,2.18-3.06,1.79-3.06,1.77-15.57-8.72-15-11.55-12.29-13.72-.29-.25-5.33-1.67-5.59-2-1.82.44-2.79,1.68-4.21.32C5.45,76.77,6.56,66.62,7.52,65.87Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-1"
                d="M16.18,89.18a9.3,9.3,0,0,0,5-1.27h.06c.09,0,1.3.56,1.3.56-1.39,2.14.2,5.53,1.88,7a80.48,80.48,0,0,0,8.16,5.64c1.86,1.25,4.23,3.43,6.64,3.26,1.2-.09,2.13-1.73,2.47-2.9S42,99.31,43,98.63s2.46-.69,3.67-.89A31.1,31.1,0,0,0,50,97a29.55,29.55,0,0,0,6.24-2.42c4-2.11,7.92-5.13,9.65-9.37,3.8-9.34-4.7-10.7-5.28-10.81a4.9,4.9,0,0,0-4.71,1.87c-.07-.07-.89-1-1.25-.84-6.46,2.39-21.54-8.39-21.54-8.39,4.16-6.35.37-6.9-2.22-9.07.49-.37,3.07.14,3.74.19.86.07.35-.72.43-1.3A6.38,6.38,0,0,1,36,54.32c1-1.49,2.4-2.33,2.64-4.22s-.24-3.5,0-5.25c0-.15,1.47.29,2.43,0A3,3,0,0,0,42.82,41a.81.81,0,0,0-.1-.18c1.23.62,3.3.32,4.78-.17s2.38-.87,4-1.41a32.41,32.41,0,0,1,4.79-1,6,6,0,0,0,3.29-1.35,2.88,2.88,0,0,0,.69-1.09,43.93,43.93,0,0,1,4-2.37c3.65-1.56,21.53,0,25.59.67A62,62,0,0,1,97.2,36c1.93.61,3.7.57,5.64,1.13a18.18,18.18,0,0,0,3.45.52c.14-.06,1.53-.37,2.06-.57a2.32,2.32,0,0,1,1.73.63c.77.69,1.47,1.49,2.2,2.23,1.43,1.46,5,7.1,6.38,8.64,2.51,2.86,2.75,9.8,3,10.19,1.92,3.13,4.58,7.81,9.44,9.23a8.12,8.12,0,0,1,2.64.89c-.77,1.56,2.35,4,2.51,4.08.81.34,1.61.71,2.4,1.09a7,7,0,0,1,2.07,3.19c.55,1.61,18.34,21.5,18.9,22.19,3,3.63,8.36,3.17,8.38,3,.71-4.66,1.71-9.78.39-14.32s-6.19-12.71-5.91-19.3a12.12,12.12,0,0,0-5.53-11.52c.08-.2,2.47-15.43-6.62-15.72-.55-2.52-.51-4.22-2-6.08A21.8,21.8,0,0,0,140,28.72c-1.21-.58-8.49-3.22-9.21-4.18a44.61,44.61,0,0,0-5.27-5.38c-2-1.71-6.2-1.25-6.26-1.24,8-9.91-20.49-12-23-12.54-1.93-.39-5.82-1.26-7.78-.81-.88.2-2.66,2.84-3.33,2.51-.33-.17-2.87-6.81-19.23.48,0,0-7.81-1.61-10.72,1.06a15.27,15.27,0,0,0-.91,1.45,26.53,26.53,0,0,0-6.61-1,9,9,0,0,0-5.07,1.65c-1.63,1.15-2.36,2.69-3.35,4.34a3.7,3.7,0,0,1-2.05,1.84c-1,.31-6.46.37-8.87,3.29-.5.6-1.35.77-1.48,1.61a6.14,6.14,0,0,0,.54,2.39c-.79-.14-2.85-3.45-8.77,4.19A7.83,7.83,0,0,0,18.36,30a1.56,1.56,0,0,0-1.31,0c-1.28,1.23-2.51,2.67-3.9,3.76-.57.45-1.82.21-2.1.3A2.54,2.54,0,0,0,9.91,35c-1.67,2.19-1.12,5.49-.9,8,.15,1.72.34,3.44.57,5.15a12.06,12.06,0,0,0,1,4.27,6.26,6.26,0,0,0,.64,1l-.58-.45A5.78,5.78,0,0,0,9,51.76C7.78,51.45,7,54.05,6.65,55c-1.22,3.46-.57,7.3-1,10.88C4,79,14.53,88.74,16.18,89.18ZM137.12,70.13A38.21,38.21,0,0,1,142,62.87a28.59,28.59,0,0,1,5.47-4.47,17.43,17.43,0,0,1,3.38-1.74c.91-.32,9.53,5.28,7.38,6.37-1.09.56-5.72,5.1-6.47,6a38.67,38.67,0,0,0-2.5,3.57c-.18.29,1.47,1.41,1.58,1.23a21.2,21.2,0,0,1,4.27-5.45c1.91-1.52,3-1.41,4.9-.35,0,1.53,4.59,16.22,5.41,18.89.43,1.4,2.41,13.44,1.18,13.71-.61.14-4.08.52-6.23-1.2-7.6-6.09-19.92-21.93-19.23-21.51,1.49.9,4.55.51,6.36.67s3.61-.85,5.2-1.71a10.64,10.64,0,0,1,3.1-1.28c.65-.11,2.12-.28,2.58.3.22.27-1.37-1.64-3.08-1.65-2.2,0-4,1.43-5.92,2.31C148.13,77.18,137.49,70.29,137.12,70.13ZM7.22,69.87c0-1.13-.14-10.13.89-13.33.29-.92,7.82,5.22,7.49,8,0,.29.48.62.67.77s.89.6.9.46a11.66,11.66,0,0,0-2.5-8.56A11.58,11.58,0,0,0,18,58.8c3,.76,4.86-2.07,5.19-4.71,0-.28-.49-.62-.67-.77s-.89-.6-.91-.46c-.24,2-1.35,4.47-3.58,4.78-1.44.2-5.37-3.08-6.06-4.67a13.57,13.57,0,0,1-.75-3.51c-.37-2.67-.67-5.37-.8-8.06-.08-1.76.07-6.25,2.74-6.12.41,0,.72.22,1.13.06a4.89,4.89,0,0,0,1.18-1.05L17.86,32c0,.15,0,.29,0,.42.07,2.26-.2,4.85.48,7,.58,1.85,4.4,6.34,4.32,6.11-.59-1.78-2.07-3.07-2.68-4.83-.69-2-.45-4.37-.51-6.45,0-.95-.36-2.48.16-3.32a3.92,3.92,0,0,1,1-.84,6.77,6.77,0,0,0,1-1c1.17-1.37,3-3.85,6.56-3.7.22,0,.79.44.8.64a1.15,1.15,0,0,1-.45,1c-.14.11.6.72.67.77a3.35,3.35,0,0,0,.59.39s.24.13.31.07a1.28,1.28,0,0,0,.47-1.1,2.16,2.16,0,0,0-.43-1.14,5.14,5.14,0,0,0-1.48-1.34,3,3,0,0,1-.14-2.06c.32-.79,1.33-1.19,2-1.61,1.42-.85,4.76-1.79,5.38-.14a5.9,5.9,0,0,1,.88,3.46c-.53,4.66-.18,4.74-.09,4.46,3.33-10.52-1-10-1-10,1-.49,2-.31,3.05-.63a3.63,3.63,0,0,0,1.93-1.63c.92-1.44,1.52-2.9,2.81-4,.48-.43,7.54-1.52,10-.67a5.28,5.28,0,0,0,.53,1.1,11.09,11.09,0,0,0,3.36,2.36c1.47.7,1.86,4.14,1.88,4,.28-1.68.52-3.45-.61-4.71-.65-.73-2.27-1.25-3.13-1.72-.1,0,1.11-3.14,2.26-3.53.26.25,7.35,6.1,8.21,7.57.38.66.71,2.25.11,2.44a13.81,13.81,0,0,1-2.23.22,7.27,7.27,0,0,0,1.46,1.27c1.13,0,2.1-1.25,6,.16.59.21,3.33,1.86,3.09,1.58-1.15-1.31-2.09-2.84-3.68-3.49A10.46,10.46,0,0,1,68,16.77c-.62-.79-7.94-8-7.4-8,8.49-.29,5,1.64,6.88.41,13-8.32,16.7.79,17.25,1.06.71.35,1.66-1.37,2.22-1.79,0,.29-.66,3-.64,3-.23,1.12.87,3.72,1.32,4.47a90.55,90.55,0,0,0,5.69,7.56c-1.33-2.09-2.66-4.17-4-6.27a6.8,6.8,0,0,1-1.15-3c-.1-1.21,1.24-6.43,2.31-6.76.37-.11,5.83-2.3,13.1,6a4.63,4.63,0,0,1,1.18,2.85,16.09,16.09,0,0,1-.66,4.92c-.36,1.29-1.2,2.8-2.77,2.51-.19,0,.34.56.4.61a2.53,2.53,0,0,0,1.05.66c2.06.37,2.78-1.94,3.13-3.49a14.29,14.29,0,0,0,.26-5.75c-.68-3.6-3.28-5.77-6.35-7.4h0c4.58,1,15.64,3.92,16.48,4.39a3.13,3.13,0,0,1,1.22,2.55,57.74,57.74,0,0,1-.42,6.48c0,.19,2,1.86,2,1.62-.1-.49,0-3,4.19-2.44,2,.26,4.73,5,4.51,6s-5.21,6.19-3.88,6.36c1,.12,5.39-4.28,5.53-5.59.24-2.25,4.85,1.36,7.75,2.77,1.62.79,3.32,1.44,4.87,2.37A12.21,12.21,0,0,1,146.31,38c1.62,3.22,2.58,7.48-.21,10.35-2.24,2.3-5.75,2.8-8.79,3.16-.23,0,.34.55.41.61.22.2.73.7,1.05.66,3.82-.46,8.82-1.29,10.31-5.45a7.68,7.68,0,0,0,.36-3.53c.2.14,3.15.23,3.92,1.32s2.39,10.38,2,11.14c-.22-.12-4-1.48-5.72-.94a21.32,21.32,0,0,0-7.33,4.54,29,29,0,0,0-6.78,8.74A15.08,15.08,0,0,0,131.12,66a6.89,6.89,0,0,1-3.44-2.86L127,62c-1.09-1.78-2.09-3.7-3.33-5.39-.3-.39-.6-7,1.11-7.07h0a59.73,59.73,0,0,1,4.65,5c.27.37,3.9-2.61,1.83-4-1.1-.72-2.08-1.43-3.38-2.32-.5-.35-.33-1.85.45-2.88.6-.78,1.65-2,2.64-1.86,2.23.35,6.8,1.76,6.89,1.55s-.75-.77-.89-.87a25,25,0,0,0-4.88-3c-1.16-.5-3.93-1.51-4.86-.18-.47.67-.63,1.56-1.07,2.28a7.08,7.08,0,0,1-1.84,2,5.42,5.42,0,0,1-2.57,1c-.86.09-10.89-10.7-10.3-11.54,1-1.49,1.1-3.3,1.76-4.94a8.5,8.5,0,0,1,3.26-3.95c.07-.05-4.11,1-4.77,2.55s-.75,3.45-1.73,5c-.82,1.25-3.91,2.22-4.45,2.42-1.6.2-6.06-.78-7.69-1.37a35.59,35.59,0,0,0-8.68-2.08,44.33,44.33,0,0,0-9.9-.36,2.06,2.06,0,0,0,.63-1,11.84,11.84,0,0,0-.09-5.13c-.66-3.92-2.4-5.31-1.66-1.57.33,1.69.8,4.15.06,5.78s-3.12,1.47-4.6,1.48c-3.47,0-7.12-.72-10.46.53a12.5,12.5,0,0,0-2.51,1.38c0-.22,0-.44,0-.65-.13-3.46-3.81-11.42-3.72-11.19A30.15,30.15,0,0,1,59,32.28a6.41,6.41,0,0,1-.36,2.35h0c-1.52.86-8.67,3.32-10.21,4s-3.22,1.77-5,1.69c-2.15-.09-3.61-2.27-4.37-4.07a10.15,10.15,0,0,1-.79-4.74c0-.55-1.59-1.15-1.58-1.23a10.86,10.86,0,0,0,3.11,8.34,15.57,15.57,0,0,0,1.27,1.17,2.89,2.89,0,0,1-1.42,3.49,2.39,2.39,0,0,1-2,.05A6.34,6.34,0,0,1,36.11,42Q32.45,38.58,29,34.94c-.24-.24-.88-.91-1.24-.91s5.88,6.46,9,9.15c.28.25.59,4.07.31,5.87s-1.81,2.7-2.71,4.21c-.51.85-.41,1.75-1,2.77-.24.4-4.75-.59-5.65.31-.22.22,1.37,3.15,1.55,3.22a4.62,4.62,0,0,1,1.9,7.52c-.17.18,16.15,15.07,23,10.34.38-.27,1.17,1.32,1.18,1.38s-.59,5.88-1.89,7.26a37.91,37.91,0,0,1-4.11,3.8c-1.34,1.08-3.3,2.54-5,1.73-.35-.16-.36,0-.17.21a3.09,3.09,0,0,0,1.12.87c2.29,1.06,4.38-.52,6.1-1.94a28.6,28.6,0,0,0,5.34-5.43c1.21-1.72,2.3-6.69,2-7.07.77-1.43,6,2.71,5.8,3.67a14.08,14.08,0,0,1-2.47,5.37A21.59,21.59,0,0,1,53.36,94a30.27,30.27,0,0,1-5.54,1.92c-1.78.44-3.69.48-5.43,1a2.66,2.66,0,0,0-1.9,1.65c-.3.86-.21,1.84-.8,2.58-1.84,2.32-4.44-.56-6.14-1.7-2.14-1.44-4.43-2.86-6.56-4.3a7.93,7.93,0,0,1-3.17-3.89c-.26-1-.18-.93.44-1.77,0,0,7.18,3.71,7.18,3.71.34.19-.21-2.14-.61-2.36-2.71-1.46-9.62-4.53-9.91-4.4-1.15-.77-2.62,1-3.76.82-1.36-.2-2.06-1.31-2.8-2.36a50.22,50.22,0,0,1-4.7-8.29c2.37.68.13-4,2.29-5.5a1.26,1.26,0,0,1,1.56.25c1.69,1.92,3.65,4.24,6.24,5.24s5.12.47,7.6,1.15c1.28.35,2.34,1.18,3.64,1.49s-2.95-2-4.17-2.48C25,76.1,23,76.17,21.13,76A6.92,6.92,0,0,1,17,74.43a26.49,26.49,0,0,1-2.15-2.35l-5-5.71a2.83,2.83,0,0,0-1.11-.87c-.26,0-.45-.11-.17.21,2.05,2.34-.27,11.92-1.11,8.36A18.42,18.42,0,0,1,7.22,69.87Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-3"
                d="M104,56S82.75,52,75.38,67.87c-1.86,4-.37,4.9,2.38,2,1.71-1.81,10.44-9.74,17.68-9,0,0,8.08-2.64,13.68,13.66,0,0,5.11,12.16,14.84,3.16,0,0,7-15.08-14.35-26.51s-49.66-5-54,5.35c-2,4.62-2,8.93,8.51,13.83l6.08,2S54.79,57.87,75.55,52.11C75.55,52.11,91.36,48.71,104,56Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-1"
                d="M60.2,51.31l5.9-3.07s4.72-3.66,4.85-6.52c.07-1.72-4-5.16-4-5.16l.12,1.66A31.44,31.44,0,0,1,69.46,41c.87,1.25-.17,2.11-1.15,3.45a9.78,9.78,0,0,1-6,3.79c1.08-5.47-2.59-3.16-2.25-3.16C63.23,45.12,60,51.38,60.2,51.31Z"
                transform="translate(-0.63 0.13)"
              />

              <path
                class="cls-1"
                d="M92.47,70c-2.39-3.94-5.17-3.59-6.09-2.23-.13.18-2.26,4-2.37,4.14a12.57,12.57,0,0,0-3.58,1c-6.24,2.6-1.59,9.73-1.25,9.5s-3.14-7.84,4-8.85a28.49,28.49,0,0,0-1.09,2.83c-.13.39.76,1.43.82,1.37.28-.33,4.24-8.48,4.8-8.69a3.36,3.36,0,0,1,2.88,1.37C91,70.89,92.56,70.13,92.47,70Z"
                transform="translate(-0.63 0.13)"
              />

              <path
                class="cls-3"
                d="M84.66,98.24A74,74,0,0,1,76,104a4.79,4.79,0,0,0-2.71,5l1.17,6.86S55.33,114.33,46,110.14l-4.31-3s-1.74-1.58-1.48-2.49c2-7.22,5.12-6.49,5.12-6.49l.83-.06c3.91-.3,7.34-2,10.9-3.85l1.8-.86s2.62-2.71,9.17-6.49C76.33,82.13,83.89,82.69,84.66,98.24Z"
                transform="translate(-0.63 0.13)"
              />
            </g>
            <g id="front-lobe">
              <path
                class="cls-2"
                d="M58.56,78.23,54.12,77c-8.43,4.52-24-8.25-23.06-9.87a5.3,5.3,0,0,0-1.9-7.52c-1.53-.8-1.48-3.2-1.55-3.22-2.23-.69,5.09.64,5.29-.49s.11-.53.85-1.59c.51-.73,1.94-2.5,2.38-3.29,1.06-1.89.63-5.48.57-7.79.24.17,1.77.16,2,.33.63.42,1.89-1.23,2.14-1.63.71-1.1.1-.49.32-1.7.16,0,0,.88-1.76-2-3.74-6.09-5.82-11.12-12-12.74-1.7,1.22-7,4.47-8.11,6.2-1.5.15-6,2.88-6.76,3.39-3.77,2.56-.86,18.12-.3,20a3.11,3.11,0,0,0-2.67-2C8,53,7.8,55.07,8.42,57.25c-.45.59-1.1,7.36-.9,8.31-1,.75-2.07,10.9,8.23,20.76,1.42,1.36,2.39.12,4.21-.32.26.36,5.3,1.77,5.59,2-2.67,2.17-3.28,5,12.29,13.71,0,0,1.46.42,3.06-1.76,0,0-.35-2.77.86-3,7.08-1.21,16.75-3.83,20.65-10.16C62.69,86.37,67,82.25,58.56,78.23Z"
                transform="translate(-0.63 0.13)"
              />
            </g>
            <g id="VTA-2">
              <path
                class="cls-3"
                d="M84.66,98.24A74,74,0,0,1,76,104a4.79,4.79,0,0,0-2.71,5l1.17,6.86S55.33,114.33,46,110.14l-4.31-3s-1.74-1.58-1.48-2.49c2-7.22,5.12-6.49,5.12-6.49l.83-.06c3.91-.3,7.34-2,10.9-3.85l1.8-.86s2.62-2.71,9.17-6.49C76.33,82.13,83.89,82.69,84.66,98.24Z"
                transform="translate(-0.63 0.13)"
              />
            </g>
            <g id="NAc-2">
              <path
                class="cls-4"
                d="M18.11,63.1a9.66,9.66,0,0,1,6.74.89,17.43,17.43,0,0,1-1.69-2.74c-.23-.46-2.32-8.31-2.28-8.58a9.37,9.37,0,0,1,2.79,1.66,25.32,25.32,0,0,0,4.19,11.24,11.48,11.48,0,0,0,1.57,1.84c.93.91,2.28,2.27,3,3a18.1,18.1,0,0,0,1.36,1.26c2.13,1.77,7.68,6.39,8.21,6.73,3.4,2.18,6.76,4.41,10.06,6.74.41.15.82.29,1.24.4a12,12,0,0,0,2,.33,33.22,33.22,0,0,0,4.56-.27c.59-.11,1.18-.23,1.77-.38,1-.24,2-.51,2.95-.78a8.73,8.73,0,0,0,1.48-.9c-8.29-2.31-7.1-13.41-2.74-18.79a15.09,15.09,0,0,1,6-4.4c-.09-.08-.29-.25-.29-.37V54.83c0-.24.63.2.69.25a4.75,4.75,0,0,1,.6.49c.08.08.29.25.29.37v4a16.19,16.19,0,0,1,5.23-.74c.36,0,.8.43,1,.65.06.06.63.62.41.62A15.45,15.45,0,0,0,61.42,75.52a9.18,9.18,0,0,0,1.5,5.71c1.38,1.75,4.34,1.52,6.35,1.43a29.32,29.32,0,0,1,5.85.11,22.51,22.51,0,0,1,5.6,1.76A57.56,57.56,0,0,1,92.08,92c.1.08.8.6.67.77s-.84-.42-.9-.47l-1.26-1,1.78,1.52c1,.91-.12.42-.65,0-4.55-3.94-9.59-8.17-15.85-8.69-3.37-.28-6.55.68-9.74,1.61a16.17,16.17,0,0,1-6.06,1.42c-.42,0-.84.1-1.26.12a12.57,12.57,0,0,1-1.74,0h-.54a11.26,11.26,0,0,1-2.4-.3.23.23,0,0,1-.14,0,11.85,11.85,0,0,0-14.17,6.46c0,.13-1.74-.86-1.57-1.23a11.69,11.69,0,0,1,4.13-4.88c-.21-.14-.44-.28-.64-.39a12.9,12.9,0,0,0-1.17-.6,16.63,16.63,0,0,0-2.17-.81,3.27,3.27,0,0,1-.84-.41,3.51,3.51,0,0,1-.56-.46c-.09-.1-.51-.53-.12-.42a19.1,19.1,0,0,1,5.6,2.66c.08.06.15.14.24.2a12.15,12.15,0,0,1,7.16-1.84c-1.55-.87-3-1.91-4.49-2.92A111.61,111.61,0,0,1,36,75c-.22-.18-7.55-6.68-8.09-7.21-.28-.27-2.1-2.46-2.34-2.86a9.08,9.08,0,0,0-6-.52c-.29.07-.85-.48-1-.65S17.88,63.16,18.11,63.1Z"
                transform="translate(-0.63 0.13)"
              />
            </g>
            <g id="front-lobe-arrows-2">
              <path
                class="cls-5"
                d="M39.42,85.89a44.27,44.27,0,0,1-7.1,1.6c-7.16.22-9.41-2.43-14.58-7L16.06,79"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M13.8,77A15.37,15.37,0,0,0,18.58,78l-2.22,1.2-.94,2.35A15.08,15.08,0,0,0,13.8,77Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M60,74.08s-13.43-3-20.31-7.91C24,55.05,27.07,40.75,29.27,34.82"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M30.49,32.06A15.12,15.12,0,0,0,31,36.93L29.14,35.2l-2.52-.15A15.29,15.29,0,0,0,30.49,32.06Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M38.2,78.09s-11.22,1-18.82-7.28c-6.48-7.11-5.23-17-4.07-21.88"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M16.15,46a15.09,15.09,0,0,0,1.14,4.76l-2.06-1.47-2.52.19A15.16,15.16,0,0,0,16.15,46Z"
                transform="translate(-0.63 0.13)"
              />
            </g>
            <g id="LC-arrows-3">
              <path
                class="cls-5"
                d="M89.84,92.64S84.72,84,71,90.13,23.7,84.19,21.94,65s27.2-39.74,50.31-38.2S133.81,58,134.51,58.34c2.61,1.35,28.34,14.64,30.81,6,.46-1.58-1.4-3.22-3.12-4.35"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M159.57,58.53a15.17,15.17,0,0,0,4.89.08l-1.94,1.63-.45,2.49A14.93,14.93,0,0,0,159.57,58.53Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M129,54.26s32.89-15.43,21.37-20.63"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M147.49,32.74a15.33,15.33,0,0,0,4.8-.93l-1.56,2,.08,2.53A15,15,0,0,0,147.49,32.74Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M102,37.62S123,14.24,114.24,5c-3.31-3.5-5.74-2.44-7.47-1.16"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M104.19,5.38a15,15,0,0,0,2.43-4.24l.49,2.48,2,1.59A15.22,15.22,0,0,0,104.19,5.38Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M75.67,26.7S88-6.48,72,2.52"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M69.46,4.15A15.06,15.06,0,0,0,71.83-.13l.53,2.47,2,1.56A15,15,0,0,0,69.46,4.15Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M46,32.06S42.45,4,35.8,13.18"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M34.3,15.8a15.2,15.2,0,0,0,.13-4.89L36,12.86l2.48.47A15.06,15.06,0,0,0,34.3,15.8Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M32.32,42.8S21.68,14.13,16.73,25.51"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M15.81,28.38a15,15,0,0,0-.9-4.8l2,1.57,2.53-.06A15,15,0,0,0,15.81,28.38Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M21.78,60.35S1.3,47.64,3.21,58.46"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M4.05,61.36A15.28,15.28,0,0,0,.63,57.88l2.52.19,2.06-1.46A15.11,15.11,0,0,0,4.05,61.36Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M35,83.5S27.29,96,21.87,96.88c-3,.48-4.48-1.56-5.18-3.47"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M16.05,90.46a15.43,15.43,0,0,0,3.29,3.62l-2.51-.3-2.12,1.38A14.81,14.81,0,0,0,16.05,90.46Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M51.62,90.39s-4.91,17.2,17.83,13.11"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M72.41,102.88A14.89,14.89,0,0,0,68.66,106l.39-2.5-1.29-2.17A15.05,15.05,0,0,0,72.41,102.88Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M74.77,88.78s-7.41-2.41-3.58-8.66"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M73.05,77.74a15,15,0,0,0-.69,4.84L71,80.46l-2.41-.75A15,15,0,0,0,73.05,77.74Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M61.79,91.73s-5.18-3.94-2.88-9.36"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M60.51,79.81a14.93,14.93,0,0,0-.15,4.89l-1.6-2-2.48-.48A15.18,15.18,0,0,0,60.51,79.81Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M93.54,99.51s.58,8.61-2.51,12.66"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M88.61,114a15.2,15.2,0,0,0,1.89-4.52l.79,2.4,2.15,1.33A15,15,0,0,0,88.61,114Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M94.75,97.78s4.23,32.15,9.39,40.85"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M106.3,140.74a15.19,15.19,0,0,0-4.68-1.41l2.3-1L105,136A15.12,15.12,0,0,0,106.3,140.74Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M94.56,94.24s16.7,16.86,25,7.12"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M121.16,98.82a15,15,0,0,0-.41,4.88l-1.5-2L116.8,101A14.86,14.86,0,0,0,121.16,98.82Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M100.52,99.23s21.3,14.17,14.82,22.81"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M113.11,124.08a15.41,15.41,0,0,0,1.45-4.67l1,2.31,2.26,1.13A15.18,15.18,0,0,0,113.11,124.08Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M107,103.64s21.07,9.7,27.05,2.71"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M135.32,103.64a15.09,15.09,0,0,0,.13,4.89l-1.71-1.87-2.51-.34A15,15,0,0,0,135.32,103.64Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M103.71,101.56s25.65,12.9,26.84,21.73"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M129.86,126.23a15.13,15.13,0,0,0-1.52-4.65l2.17,1.3,2.5-.39A15.27,15.27,0,0,0,129.86,126.23Z"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-5"
                d="M92.61,90.6s-9.19-6.87-.36-13.93"
                transform="translate(-0.63 0.13)"
              />
              <path
                class="cls-6"
                d="M94.75,75a14.93,14.93,0,0,0-2.12,4.41L92,76.94l-2.08-1.45A15.09,15.09,0,0,0,94.75,75Z"
                transform="translate(-0.63 0.13)"
              />
            </g>
            <g id="LC-center">
              <ellipse
                class="cls-7"
                cx="92.35"
                cy="94.8"
                rx="2.29"
                ry="4.85"
                transform="translate(-21.1 25.74) rotate(-14.23)"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="brain-steps">
        <Scrollama
          :debug="false"
          :offset="0.5"
          @step-enter="brainHandler"
          class="main_scrollama_brain"
        >
          <div class="step-brain" style="opacity: 0"></div>
          <div class="step-brain" data-step-no="1">
            <div class="step-brain-text">
              <h3 class="phase-title">Phase 1:</h3>
              <h2 class="brain-title">The Brain Before Opioids</h2>
              <div class="line-sep-cont"><div class="line-sep"></div></div>
              <p>
                Your body naturally produces endorphins, which is the body’s
                natural version of opioids, and this is the same reward circuit
                that is accessed after working out, falling in love, or eating a
                good meal. They relieve pain and a create a general feeling of
                wellbeing.
              </p>
            </div>
          </div>
          <div class="step-brain" data-step-no="2">
            <div class="step-brain-text">
              <h3 class="phase-title">Phase 2:</h3>
              <h2 class="brain-title">The Reward System</h2>
              <div class="line-sep-cont"><div class="line-sep"></div></div>
              <p>
                When an opioid is first taken, it creates a tidal wave in the
                reward circuits of the brain. It floods your frontal lobe with
                dopamine and replaces pain receptors with euphoria- encouraging
                repeated use and making the user seek the same high as their
                first dose.
              </p>
            </div>
          </div>
          <div class="step-brain" data-step-no="3">
            <div class="step-brain-text">
              <h3 class="phase-title">Phase 3:</h3>
              <h2 class="brain-title">The Dependence to Feel Normal</h2>
              <div class="line-sep-cont"><div class="line-sep"></div></div>
              <p>
                At this phase, the mesolimbic reward system changes and
                dependence means that the user no longer feels pleasure in the
                activities they used to without opioids. The brain functions
                more or less normally when the drugs are present and abnormally
                when they are not. Opioid tolerance increases because the brain
                cells that have opioid receptors on them gradually become less
                responsive to stimulation.
              </p>
            </div>
          </div>
          <div class="step-brain" data-step-no="4">
            <div class="step-brain-text">
              <h3 class="phase-title">Phase 4:</h3>
              <h2 class="brain-title">The Changed Set Point Model</h2>
              <div class="line-sep-cont"><div class="line-sep"></div></div>
              <p>
                Your baseline is altered, no longer producing natural opioids
                and depending entirely on the medication to regulate. This is
                what addiction looks like. Withdrawal symptoms become
                unbearable, known as 'dopesick'. Cortisol, the stress hormone,
                is increased, making stress a driver for many addicts.
              </p>
            </div>
          </div>
          <div class="step-brain" data-step-no="5">
            <div class="step-brain-text">
              <h3 class="phase-title">Phase 5:</h3>
              <h2 class="brain-title">
                The Normalizing Effects of MAT <br />
                <span class="smaller">[Medication-Assisted Treatment]</span>
              </h2>
              <div class="line-sep-cont"><div class="line-sep"></div></div>
              <p>
                Medication Assisted Treatment, or MAT, causes dependence, but
                because of its steadier influence on opioid receptors, it
                alleviates cravings and compulsive drug use. It moderates the
                exaggerated cortisol stress response that increases the danger
                of relapse in stressful situations. MAT is the medical standard
                in recovery and is most effective when combined with appropriate
                psychosocial treatments.
              </p>
            </div>
          </div>
          <div class="step-brain invisible" data-step-no="6">
            <div class="step-brain-text"></div>
          </div>
          <div class="step-brain invisible" data-step-no="6">
            <div class="step-brain-text"></div>
          </div>
        </Scrollama>
      </div>
    </div>
  </div>
</template>
  
  <script>
import "intersection-observer";
import Scrollama from "../../vue-scrollama/src/Scrollama.vue";
import * as d3 from "d3";
const brainFill1 = d3.selectAll(".cls-2");
const brainFill2 = d3.selectAll(".cls-3");
export default {
  name: "App",
  components: {
    Scrollama,
  },
  data() {
    return {
      currStep: null,
    };
  },
  methods: {
    brainHandler({ element, index, direction }) {
      if (direction === "down") element.classList.add("active");
      // console.log(index);
      if (index === 0) this.phase0();
      if (index === 1) this.phase0();
      if (index === 2) this.phase2();
      if (index === 3) this.phase3();
      if (index === 4) this.phase4();
      if (index === 5) this.phase5();
    },
    brainStart() {
      d3.select("#front-lobe").attr("opacity", 0);
      d3.select("#LC-arrows-3").attr("opacity", 0);
      d3.select("#LC-center").attr("opacity", 0);
      d3.select("#front-lobe-arrows-2").attr("opacity", 0);
      d3.select("#VTA-2").attr("opacity", 0);
      d3.select("#brain-base").attr("opacity", 0.85);
    },
    phase0() {
      d3.select("#front-lobe").attr("opacity", 0);
      d3.select("#LC-arrows-3").attr("opacity", 0);
      d3.select("#LC-center").attr("opacity", 0);
      d3.select("#VTA-2").attr("opacity", 0);
      d3.select("#front-lobe-arrows-2").attr("opacity", 0);
      d3.select("#brain-base")
        .transition()
        .ease(d3.easeLinear)
        .duration(2000)
        .attr("opacity", 0.85);
      brainFill1.style("fill", "#f6adcd");
    },
    phase2() {
      d3.select("#brain-base")
        .transition()
        .ease(d3.easeLinear)
        .duration(2000)
        .attr("opacity", 0.4);
      d3.select("#front-lobe").attr("opacity", 0.5);
      d3.select("#LC-arrows-3").attr("opacity", 0);
      d3.select("#VTA-2").attr("opacity", 0.4);
      d3.select("#front-lobe-arrows-2").attr("opacity", 1);
      const arrowLineDrawn = d3.selectAll(".cls-5").attr("opacity", 1);
      const arrowDrawn = d3.selectAll(".cls-6").attr("opacity", 0);
      arrowLineDrawn
        .attr("stroke-dasharray", function () {
          return this.getTotalLength();
        })
        .attr("stroke-dashoffset", function () {
          return this.getTotalLength();
        })
        // reveal the paths
        .transition()
        .duration(4000)
        .attr("stroke-dashoffset", 0);
      arrowDrawn
        // reveal the arrowheads
        .transition()
        .duration(6000)
        .attr("opacity", 1)
        .attr("transform", function () {
          return "translate(" + this.x + "," + this.y + ")";
        });
      d3.select("#LC-center").attr("opacity", 1);
    },
    phase3() {
      d3.select("#brain-base")
        .transition()
        .ease(d3.easeLinear)
        .duration(2000)
        .attr("opacity", 1);
      brainFill2
        .transition()
        .ease(d3.easeLinear)
        .duration(4000)
        .style("fill", "#f17fb1")
        .attr("opacity", 1);
      brainFill1
        .transition()
        .ease(d3.easeLinear)
        .duration(4000)
        .style("fill", "#f17fb1")
        .attr("opacity", 1);
      d3.select("#front-lobe").attr("opacity", 0);
      d3.select("#LC-arrows-3").attr("opacity", 1);
      d3.select("#VTA-2").attr("opacity", 0);
      d3.select("#front-lobe-arrows-2").attr("opacity", 0);
      const arrowLineDrawn = d3.selectAll(".cls-5").attr("opacity", 1);
      const arrowDrawn = d3.selectAll(".cls-6").attr("opacity", 0);
      arrowLineDrawn
        .attr("stroke-dasharray", function () {
          return this.getTotalLength();
        })
        .attr("stroke-dashoffset", function () {
          return this.getTotalLength();
        })
        // reveal the paths
        .transition()
        .duration(4000)
        .attr("stroke-dashoffset", 0);
      arrowDrawn
        // reveal the arrowheads
        .transition()
        .duration(6000)
        .attr("opacity", 1)
        .attr("transform", function () {
          return "translate(" + this.x + "," + this.y + ")";
        });
    },
    phase4() {
      const arrowLineDrawn = d3.selectAll(".cls-5").attr("opacity", 1);
      const arrowDrawn = d3.selectAll(".cls-6");
      arrowLineDrawn
        .transition()
        .delay(0)
        .on("start", function repeat() {
          d3.active(this)
            .duration(1000)
            .attr("stroke-dasharray", function () {
              return this.getTotalLength();
            })
            .attr("stroke-dashoffset", function () {
              return this.getTotalLength();
            })
            .transition()
            .delay(200)
            .duration(1000)
            .attr("stroke-dasharray", function () {
              return this.getTotalLength();
            })
            .attr("stroke-dashoffset", function () {
              return this.getTotalLength();
            })
            // reveal the paths
            .transition()
            .duration(1000)
            .attr("stroke-dashoffset", 0)
            .transition()
            .delay(200)
            .duration(1000)
            .attr("stroke-dasharray", function () {
              return this.getTotalLength();
            })
            .attr("stroke-dashoffset", function () {
              return this.getTotalLength();
            })
            .transition()
            .delay(200)
            .duration(1000)
            .attr("stroke-dasharray", function () {
              return this.getTotalLength();
            })
            .attr("stroke-dashoffset", function () {
              return this.getTotalLength();
            })
            // reveal the paths
            .transition()
            .duration(2000)
            .attr("stroke-dashoffset", 0)
            .on("start", repeat);
        });
      arrowDrawn
        .attr("transform", function () {
          return "translate(" + this.x + "," + this.y + ")";
        })
        .transition()
        .delay(350)
        .on("start", function repeat() {
          d3.active(this)
            .attr("opacity", 0)
            .transition()
            .delay(350)
            .duration(2500)
            .attr("opacity", 1)
            .transition()
            .delay(350)
            .duration(2500)
            .attr("opacity", 0)
            .transition()
            .delay(350)
            .duration(2500)
            .attr("opacity", 1)
            .transition()
            .delay(350)
            .on("start", repeat);
        });
      d3.select("#brain-base")
        .transition()
        .delay(350)
        .on("start", function repeat() {
          d3.active(this)
            .attr("opacity", 0.5)
            .transition()
            .delay(350)
            .duration(2500)
            .attr("opacity", 1)
            .transition()
            .delay(350)
            .duration(2500)
            .attr("opacity", 0.5)
            .transition()
            .delay(350)
            .duration(2500)
            .attr("opacity", 1)
            .transition()
            .delay(350)
            .on("start", repeat);
        });
      d3.select("#front-lobe").attr("opacity", 0);
      d3.select("#LC-arrows-3").attr("opacity", 1);
      d3.select("#VTA-2").attr("opacity", 0);
      d3.select("#front-lobe-arrows-2").attr("opacity", 0);
      //animate arrows
    },
    phase5() {
      d3.select("#brain-base")
        .transition()
        .ease(d3.easeLinear)
        .duration(2000)
        .attr("opacity", 0.7);
      //animate arrows
      const arrowLineDrawn = d3.selectAll(".cls-5").attr("opacity", 1);
      const arrowDrawn = d3.selectAll(".cls-6");
      arrowLineDrawn
        .transition()
        .duration(4000)
        .attr("stroke-dasharray", function () {
          return this.getTotalLength();
        })
        .attr("stroke-dashoffset", function () {
          return this.getTotalLength();
        });
      arrowDrawn
        .transition()
        .duration(4000)
        .attr("transform", "translate(0,200)")
        .attr("opacity", 0);
    },
  },
  mounted() {
    this.brainStart();
  },
};
</script>
  
  <style type="text/css">
.main {
  display: relative;
}
.smaller {
  font-size: 23px;
}
.main__graphic {
  display: relative;
  flex: 1;
  top: 5vh;
  position: sticky;
  height: 200vh;
}
.brain-steps {
  padding-left: 150px;
}
.step-brain-text {
  max-width: 100%;
  border-radius: 10px;
  /* background: white; */
  backface-visibility: inherit;
  padding: 0;
  pointer-events: all;
  font-family: "Inter var", sans-serif;
  text-align: left;
  line-height: 1.5;
}
.phase-title {
  /* color: #a4bfe2; */
  color: #adcdf6;
  line-height: 0.3;
  text-align: left;
}
.brain-title {
  text-align: left;
  line-height: 1.5;
}
.step-brain {
  padding: 5vh;
  margin: 0 3rem;
  margin-bottom: 80vh;
  background-color: #212b38;
  border: 1px solid #ccc;
  display: relative;
  flex: 1;
  justify-content: left;
  max-width: 22%;
}
.step.active {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
  position: -webkit-sticky;
}
.line-sep-cont {
  margin: 0px 0;
  /* display: flex; */
  /* flex-direction: row;
	flex-wrap: nowrap; */
  justify-content: left;
}
.line-sep {
  width: 50px;
  height: 1px;
  background: #8097b5;
}
:last-child {
  margin-bottom: 0;
}
.brain-svg {
  width: 1000px;
  height: 1000px;
  height: 100vh;
}
.cls-1,
.cls-4,
.cls-5 {
  fill: none;
}
/* stroke for brain */
.cls-1,
.cls-3 {
  stroke: #b65b85;
  /* stroke: #91486a; */
}
.cls-1,
.cls-3,
.cls-4,
.cls-5,
.cls-7 {
  stroke-miterlimit: 5;
}
/* brain fill color */
.cls-2,
.cls-3 {
  fill: #f6adcd;
  /* fill: #f396bf; */
  /* fill: #f17fb1; */
}
.cls-4 {
  stroke: #94104a;
}
.cls-5 {
  stroke: #adcdf6;
}
.cls-7 {
  stroke: #b72d2c;
}
.cls-6 {
  fill: #adcdf6;
}
.cls-7 {
  fill: #ed516b;
}
.invisible {
  opacity: 0;
}
</style>